import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import * as $ from 'jquery';


const CSS_CLASS_IS_HIDDEN = 'is-hidden';
const EVENT_TYPE_CLICK = 'click';
const DATA_ATTR_TRIGGER_VCC = 'trigger-vcc';
const DATA_ATTR_ELEMENT_VALUE = 'element-value';
const DATA_ATTR_ELEMENT_NAME = 'element-name';
const DATA_ATTR_HIDE_BUTTON = 'hide-button';

/**
 * Button module implementation.
 *
 * @author Nikola Tica
 * @class Button
 * @extends Tc.Module
 */
export default class Button extends Module {
	private $button! : JQuery;
	private triggerVCC! : boolean;
	private hideButtonAfterTrigger! : boolean;
	private $controleElement! : JQuery;
	private controleElementName! : string;
	private controlElementValue! : string;

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {
		this.$button = this.$ctx.find('.button');
		this.triggerVCC = !!this.$ctx.data(DATA_ATTR_TRIGGER_VCC);
		this.controlElementValue = this.$ctx.data(DATA_ATTR_ELEMENT_VALUE);
		this.hideButtonAfterTrigger = !!this.$ctx.data(DATA_ATTR_HIDE_BUTTON);
		this.controleElementName = this.$ctx.data(DATA_ATTR_ELEMENT_NAME);

		this.$controleElement = $(`[name=${this.controleElementName}]`);

		if(this.triggerVCC) {
			this.$button.on(EVENT_TYPE_CLICK, this.triggerVcc.bind(this));
		}

		if(this.$ctx[0].nodeName.toLowerCase() === 'sdx-button') {
			this.$ctx.on('click', () => SCS.portal.datalayer.trackEvent(
				this.$ctx.data('track-action'),
				this.$ctx.data('track-label'),
				this.$ctx.data('track-location'),
				this.$ctx.data('track-category'),
			));
		}

		callback();
	}

	private triggerVcc() {
		this.$controleElement.val(this.controlElementValue);
		this.$controleElement.trigger('change');

		if(this.hideButtonAfterTrigger) {
			this.hideButton();
		}
	}

	private hideButton() {
		this.$button.addClass(CSS_CLASS_IS_HIDDEN);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/sdx/Tc.Module.Button.ts